// extracted by mini-css-extract-plugin
export default {"downloading":"style_downloading__b5FuN","spinner":"style_spinner__cwlwO","spin":"style_spin__xvmWa","icon":"style_icon__yyUmw"};